import React, { useState, useEffect } from 'react';
import { Navigation, FreeMode, Scrollbar, Keyboard, Mousewheel } from 'swiper/modules';
import cx from 'classnames';
import { Swiper, SwiperSlide } from 'swiper/react';
import { ChevronDown } from '../../../icons/index.js';
import styles from './index.module.scss.js';
import { GradientButtonV2 } from '../../buttons/GradientButtonV2/index.js';

const Next = ({ ...props }) => /* @__PURE__ */ React.createElement(
  "button",
  {
    ...props,
    className: cx(styles.button, props.className),
    type: "button"
  },
  /* @__PURE__ */ React.createElement(ChevronDown, null)
);
const Tabs = ({
  defaultActiveIndex = 0,
  buttons = [],
  onChange = () => {
  },
  animation = {
    "data-aos": "fade-up",
    "data-aos-delay": "50",
    "data-aos-duration": "1000"
  },
  v2,
  className,
  ...props
}) => {
  const [activeIndex, setActiveIndex] = useState(defaultActiveIndex);
  const [swiper, setSwiper] = useState(null);
  const [showNext, setShowNext] = useState(false);
  useEffect(() => {
    setActiveIndex(defaultActiveIndex);
  }, [defaultActiveIndex]);
  useEffect(() => {
    if (swiper) {
      setShowNext(!swiper.isEnd);
    }
  }, [swiper]);
  return /* @__PURE__ */ React.createElement(
    "div",
    {
      ...props,
      ...animation,
      className: cx(styles.box, className, {
        [styles.v2]: v2
      })
    },
    /* @__PURE__ */ React.createElement(
      "div",
      {
        className: cx(styles.box__inner, {
          [styles["swiper-shadow"]]: !swiper?.isEnd
        })
      },
      /* @__PURE__ */ React.createElement(
        Swiper,
        {
          className: styles.swiper,
          modules: [Navigation, FreeMode, Scrollbar, Keyboard, Mousewheel],
          spaceBetween: 0,
          slidesPerView: "auto",
          height: 60,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0,
          direction: "horizontal",
          freeMode: true,
          onSlideChange: (s) => setShowNext(!s.isEnd),
          onReachEnd: () => setShowNext(false),
          onFromEdge: () => setShowNext(true),
          mousewheel: {
            thresholdDelta: 0.1,
            sensitivity: 10
          },
          onBeforeInit: (swiperCore) => {
            swiperCore.navigation.init();
            swiperCore.navigation.update();
            setSwiper(swiperCore);
          },
          onAfterInit: (swiperCore) => {
            swiperCore.navigation.init();
            swiperCore.navigation.update();
            setSwiper(swiperCore);
          },
          onResize: (swiperCore) => {
            swiperCore.navigation.init();
            swiperCore.navigation.update();
            setSwiper(swiperCore);
          }
        },
        buttons.map(({ icon, label }, i) => /* @__PURE__ */ React.createElement(SwiperSlide, { className: styles.slide, key: `${`${i}-${label}`}` }, /* @__PURE__ */ React.createElement(
          GradientButtonV2,
          {
            active: activeIndex === i,
            onClick: (e) => {
              e.stopPropagation();
              e.preventDefault();
              setActiveIndex(i);
              onChange(i);
            },
            name: label,
            icon,
            size: "sm",
            className: cx(styles["gradient-btn"], {
              [styles.active]: activeIndex === i
            }),
            v2: true,
            withoutShine: true
          }
        )))
      ),
      showNext && /* @__PURE__ */ React.createElement(Next, { onClick: () => swiper?.slideNext() })
    )
  );
};
Tabs.displayName = "Tabs";

export { Tabs };
//# sourceMappingURL=index.js.map
